export default {
  state: () => ({
    champs: new Map(),
    catalogues: new Map(),
    ressources: new Map()
  }),
  getters: {
    champs: (state) => {

      return state.champs
    },
    catalogues: (state) => {
      return state.catalogues
    },
    ressources: (state) => {
      return state.ressources
    }
  },
  mutations: {
    SET_CHAMPS(state, champs) {
      state.champs = new Map(
        champs.map(champ => {
          return [champ.code, champ];
        }),
      );
    },
    SET_CATALOGUES(state, catalogues) {
      state.catalogues = new Map(
        catalogues.map(catalogue => {
          return [catalogue.descId, catalogue.valeurs];
        }),
      );
    },
    SET_RESSOURCES(state, ressources) {
      state.ressources = new Map(
        ressources.map(ressource => {
          return [ressource.code, ressource.valeur];
        }),
      );
    }
  }
}